import type { FrontendWidget } from '../types';
import { NearbyLocationsComponent } from './NearbyLocationsComponent';
import { NearbyLocationsComponentB } from './NearbyLocationsComponentB';
import { NearbyLocationsComponentC } from './NearbyLocationsComponentC';
import type { NearbyLocationsConfig, NearbyLocationsResolved } from './types';

export const nearbyLocationsWidget: FrontendWidget<
  NearbyLocationsConfig,
  NearbyLocationsResolved
> = {
  componentType: 'widgets.nearby-locations',
  displayName: 'Nearby Locations',
  ComponentA: NearbyLocationsComponent,
  ComponentB: NearbyLocationsComponentB,
  ComponentC: NearbyLocationsComponentC,
  // No resolveSync — lookup widget. Resolved data arrives from the backend.
};
